export default "__VITE_ASSET__Bwp4reJX__"